var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.78027 11.9999H4.89648M19.1039 11.9999H14.2201",
    stroke: "current",
    strokeWidth: 0.887961,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2211 11.9998C14.2211 10.7738 13.2272 9.77992 12.0012 9.77992C10.7751 9.77992 9.78125 10.7738 9.78125 11.9998C9.78125 13.2258 10.7751 14.2197 12.0012 14.2197C13.2272 14.2197 14.2211 13.2258 14.2211 11.9998Z",
    stroke: "current",
    strokeWidth: 0.887961,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0366 18.0203L19.1035 18.0203M4.89613 18.0203L7.58336 18.0203",
    stroke: "current",
    strokeWidth: 0.887961,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.56019 18.0203C7.56019 19.2463 8.55408 20.2402 9.7801 20.2402C11.0061 20.2402 12 19.2463 12 18.0203C12 16.7943 11.0061 15.8004 9.7801 15.8004C8.55408 15.8004 7.56019 16.7943 7.56019 18.0203Z",
    stroke: "current",
    strokeWidth: 0.887961,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.71273 5.97961H4.89648M19.1039 5.97961L11.7227 5.97961",
    stroke: "current",
    strokeWidth: 0.887961,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3343 5.97968C11.3343 4.75366 10.3405 3.75978 9.11443 3.75978C7.88842 3.75978 6.89453 4.75366 6.89453 5.97968C6.89453 7.2057 7.88842 8.19958 9.11443 8.19958C10.3405 8.19958 11.3343 7.2057 11.3343 5.97968Z",
    stroke: "current",
    strokeWidth: 0.887961,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.c2c3cce029efed2a70a0e73f0132a695.svg";
export { ForwardRef as ReactComponent };